// Lifecycle wrapper around ExtraHelpers.sideLoadResource for the evisio2 SDK.
// Gives consumers an explicit ready()/isReady() API and a single Promise to
// await — without poking at sideLoadResource's internal cache.
//
// Wired by evisio2workspaceRoot.postCreate(): kickoff() fires eagerly so the
// SDK fetch overlaps with the role-check POST; the iframe widgets are gated
// on ready() so they can rely on the SDK being loaded when they boot.

import { ExtraHelpers } from "../../../more/Helpers";

const EVISIO_SDK_URL = "https://evisio.moredms.com/sdk/evisio2sdk.js";

let _ready: Promise<void> | null = null;
let _isReady: boolean = false;

// Start the SDK load. Idempotent — repeated calls return the same Promise.
export function kickoff(): Promise<void> {
    if (_ready) return _ready;
    _ready = ExtraHelpers.sideLoadResource(EVISIO_SDK_URL, "js")
        .then(() => { _isReady = true; })
        .catch((err) => {
            console.warn("Evisio2SdkLoader: SDK failed to load", err);
            throw err;
        });
    return _ready;
}

// Await SDK availability. Auto-kicks off if no one has yet.
export function ready(): Promise<void> {
    return _ready || kickoff();
}

// Sync check for callsites that can no-op rather than await
// (e.g. event handlers firing before the SDK is up).
export function isReady(): boolean {
    return _isReady;
}
